import "../../utils/tailwind.css";
import { PageProvider, useAddWorkProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form } from "formik";

import ReactQuill from "react-quill";
import ImageUploader from "../../components/upload-image";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = useAddWorkProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto">
      <Label label="Add Careers Details" className="text-[18px] text-black" />
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2y gap-3">
              <div className="flex flex-col">
                <Label
                  label="Job name"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="careers.job_name" rootClassName="w-full" />
              </div>
              <div className=" flex flex-col">
              <Label
                label="Job Description"
                className="mb-2 text-black text-[15px]"
              />
              <FormikInput name="careers.job_description" rootClassName="w-full" as="textarea" />
              
            </div>
            </div>
            

            <div className="w-full mt-3">
              <Label
                label="Responsibilities Details"
                className="mb-2 text-black text-[16px]"
              />

              <div className="flex flex-col mb-3">
                <Label
                  label="Heading"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput
                  name="careers.responsiblities.title"
                  rootClassName="w-full"
                />
              </div>
              <div>
                <Label
                  label="Description"
                  className="mb-2 text-black text-[15px]"
                />
                <ReactQuill
                  theme="snow"
                  value={values.careers.responsiblities.description}
                  onChange={(e) =>
                    setFieldValue("careers.responsiblities.description", e)
                  }
                />
              </div>
            </div>

            <div className="w-full mt-3">
              <Label
                label="Requirements Details"
                className="mb-2 text-black text-[16px]"
              />

              <div className="flex flex-col mb-3">
                <Label
                  label="Heading"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput
                  name="careers.requirements.title"
                  rootClassName="w-full"
                />
              </div>
              <div className="mb-3">
                <Label
                  label="Description"
                  className="mb-2 text-black text-[15px]"
                />
                <ReactQuill
                  theme="snow"
                  value={values.careers.requirements.description}
                  onChange={(e) =>
                    setFieldValue("careers.requirements.description", e)
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3">
              <div className="flex flex-col mb-[3rem] ">
                <Label
                  label="CTA Label"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="careers.cta_label" rootClassName="w-full" />
              </div>
              <div className="flex flex-col">
                <Label
                  label="Assessment File"
                  className="mb-2 text-black text-[15px]"
                />
                <ImageUploader
                  className="w-full"
                  title="File"
                  name="careers.assessment_file"
                  imageUrl={values?.careers?.assessment_file}
                  onChange={(res) => {
                    setFieldValue(
                      `careers.assessment_file`,
                      res?.data?.file_url
                    );
                  }}
                />
              </div>
            </div>

            <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
